import { AlertTriangle, CheckCircle2, RefreshCw, XCircle } from 'lucide-react';
import Button from '../../ui/Button';
import { statusTone } from './semantics';

interface StatusBannerProps {
  status: string;
  mdaStatus?: string;
  earningsStatus?: string;
  onRetry?: () => void;
}

export function StatusBanner({ status, mdaStatus, earningsStatus, onRetry }: StatusBannerProps) {
  const tone = statusTone(status);

  const Icon =
    status === 'success' ? CheckCircle2 : status === 'partial' ? AlertTriangle : XCircle;

  const getMessage = () => {
    if (status === 'success') return 'Both MDA and Earnings documents analyzed successfully.';
    if (status === 'partial') {
      const failed = mdaStatus !== 'success' ? 'MDA' : 'Earnings';
      return `Partial analysis — ${failed} document is unavailable or could not be processed.`;
    }
    return 'Analysis failed for both documents. Please retry or check back later.';
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center gap-3 rounded-xl border ${tone.border} ${tone.bg} px-4 py-3`}
    >
      <Icon className={`h-4 w-4 shrink-0 ${tone.icon}`} aria-hidden="true" />
      <p className={`flex-1 text-sm font-medium ${tone.text}`}>{getMessage()}</p>
      {(status === 'failed' || status === 'partial') && onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} aria-label="Retry analysis">
          <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" />
          Retry
        </Button>
      )}
    </div>
  );
}
